import { memo } from "react";
import styles from "./freeShipping.module.scss";

function FreeShipping() {
  return (
    <div className={`container ${styles.free_shipping} `}>

      <h1>
        Free Shipping On Orders Over $99
      </h1>

      <hr />

      <p>
        PartsAvatar provides free shipping for all orders over $99 (before taxes) that are shipped through the GROUND shipping option.
        On the product pages you can see if a product qualifies for free delivery, as well as the estimated date of arrival.
      </p>

      <h2>
        Locations Where This Offer Is Not Available
      </h2>

      <p>
        Free shipping is
        {" "}

        <b>not</b>
        {" "}
        available in areas with postal codes that start with:
      </p>

      <ul className={styles.locations_list}>

        <li>J0M - Nunavik, QC</li>

        <li>X0A - Qikiqtaaluk Region, NT</li>

        <li>X0B - Kitikmeot Region, NU</li>

        <li>X0C - Kivalliq Region, NU</li>

        <li>X0E - Central Northwest Territories, NT</li>

        <li>X0G - Southwestern Northwest Territories, NT</li>

        <li>Y0A - Southeastern Yukon, YT</li>

        <li>Y0B - Central Yukon, YT</li>
      </ul>

      <p>
        Some remote areas of Canada can only be serviced by air delivery. In these cases free shipping is not available
        and extra shipping charges may apply.
      </p>

      <br />

      <br />

      <br />
    </div>
  );
}

export default memo(FreeShipping);
